import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Button, InputGroup } from "react-bootstrap";
import {
  verifyForgotPWDMobileNo_OTPApi,
  ResendForgotPwdOtpApi,
  verifyForgotPWD_OTPApi,
} from "./RamNamBookCRUD";

const OTP_LENGTH = 4;
const RESEND_TIME = 60;

const OTPVerifyPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const otpRefs = useRef([]);
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const [timer, setTimer] = useState(RESEND_TIME);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // useEffect(() => {
  //   window.history.pushState(null, "", window.location.href);
  //   const handleBack = () => {
  //     window.history.pushState(null, "", window.location.href);
  //   };
  //   window.addEventListener("popstate", handleBack);
  //   return () => {
  //     window.removeEventListener("popstate", handleBack);
  //   };
  // }, []);

  useEffect(() => {
    if (!state?.memberID) {
      // navigate("/send-otp", { replace: true });
    }
  }, []);

  useEffect(() => {
    const customer = localStorage.getItem("customer");
    if (customer) {
      navigate("/member/dashboard", { replace: true });
    }
  }, []);

  /* Autofocus first */
  useEffect(() => {
    otpRefs.current[0]?.focus();
  }, []);

  const resetOtpInputs = () => {
    setOtp(Array(OTP_LENGTH).fill(""));
    document.getElementById("otp-0")?.focus();
  };

  /* Timer */
  useEffect(() => {
    if (timer <= 0) {
      setCanResend(true);
      return;
    }
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const enteredOtp = otp.join("");

  const isFormValid = enteredOtp.length === OTP_LENGTH;

  /* OTP Change */
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);
    if (value && index < OTP_LENGTH - 1) otpRefs.current[index + 1].focus();
  };

  /* Backspace */
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0)
      otpRefs.current[index - 1].focus();
  };

  /* Verify + Reset */
  const handleSubmit = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== OTP_LENGTH) return toast.error("Enter valid OTP");
    try {
      setLoading(true);
      const response = await verifyForgotPWD_OTPApi(state.memberID, enteredOtp);

      if (response.data.isSuccess) {
        toast.success(response.data.message);
        navigate("/change-forgot-pwd", {
          state: {
            memberID: state.memberID,
          },
          replace: true,
        });
      } else toast.error(response.data.message);
    } catch {
      toast.error("Error");
    } finally {
      setLoading(false);
    }
  };

  /* Resend OTP */
  const handleResend = async () => {
    if (!canResend) return;

    try {
      const res = await ResendForgotPwdOtpApi(
        state.countryID,
        state.mobileNumber,
        "+91",
      );

      if (res.data.isSuccess) {
        toast.success("OTP Sent");
        resetOtpInputs();
        setTimer(RESEND_TIME);

        setCanResend(false);

        setOtp(Array(OTP_LENGTH).fill(""));

        otpRefs.current[0].focus();
      }
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center border-0 py-6">
      <div
        className="card p-4 shadow rounded-4 border-none mt-5"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <h6 className="text-center fw-bold mb-3" style={{ color: "#FF4F00" }}>
          OTP Verification
        </h6>

        <p className="text-center text-success">
          OTP sent to {state?.mobileNumber}
        </p>

        {/* OTP */}

        <div className="d-flex justify-content-center gap-2 mb-3">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (otpRefs.current[index] = el)}
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control text-center fw-bold"
              style={{ width: 50, height: 50 }}
              maxLength="1"
              value={digit}
              onChange={(e) => handleOtpChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>
        <Button
          className="w-100 mb-2"
          style={{
            background: "#FF4F00",
            border: "none",
          }}
          onClick={handleSubmit}
          disabled={!isFormValid || loading}
        >
          {loading ? "Processing..." : "Verify OTP"}
        </Button>

        {/* Resend */}

        <div className="text-center">
          <small className="text-muted">
            {canResend ? (
              <span
                className="text-danger"
                style={{ cursor: "pointer" }}
                onClick={handleResend}
              >
                Resend OTP
              </span>
            ) : (
              `Resend OTP in ${timer}s`
            )}
          </small>
        </div>
      </div>
    </div>
  );
};

export default OTPVerifyPage;
